<div class="search_container pos_relative">
    <div class="input_container">
        <span class="material-symbols-outlined inp_icon">
            search
        </span>
        <input (click)="dropDownOpen()" (input)="filterOptions()" [(ngModel)]="searchQuery" type="text" name="search" class="inp" [placeholder]='placeholderInput'>
    </div>
    <ul *ngIf="dropDownVisible" class="list dropdown card">
        <li class="not_found color_red" *ngIf="filteredOptions.length == 0">Не найдено</li>
        <li class="item row_hover cursor_pointer" *ngFor="let item of filteredOptions" (click)="goToPage('/customers/' + item.id, item)">
            <div class="mb" [ngClass]="{'color_red': !(item.firstname || item.lastname || item.name)}">{{ item.custom }}</div>
            <div class="match-text" *ngIf="matchesMap[item.id]?.length">
                <div class="mb" *ngFor="let match of matchesMap[item.id]" [innerHTML]="match">
                </div>
            </div>
        </li>
    </ul>
</div>
